import { render, staticRenderFns } from "./UserModalToggle.vue?vue&type=template&id=f4c1678c"
import script from "./UserModalToggle.vue?vue&type=script&lang=js"
export * from "./UserModalToggle.vue?vue&type=script&lang=js"
import style0 from "./UserModalToggle.vue?vue&type=style&index=0&id=f4c1678c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports